export default "__VITE_ASSET__B2nwT8lz__"